import { render } from "./TrgtRegister.vue?vue&type=template&id=5b9a1a73"
import script from "./TrgtRegister.vue?vue&type=script&lang=js"
export * from "./TrgtRegister.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/dongan_teens2_check/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__